import React, { useRef, useState } from 'react'
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import { Errors } from '../../../Component/ErrorShow';
import { SpecializationValidation } from '../../../Validation/Validation';
import { SpecializationImageFilePath } from '../../../services/Api';
import { useNavigate } from 'react-router-dom';
import { Button, } from '@mui/material';
import { INSERT_SPECIALIZATION } from '../../../Repository/Specialization';
import Loader from '../../../Component/Loading';
import DeleteIcons from '../../../Component/DeleteIcons';
import useUploadImage from '../../../Hooks/useUploadImage';
import { AiOutlineCloudUpload } from 'react-icons/ai';
import { TextInput } from '../../../Component/Inputs';
import { getlocalStorage } from '../../../utils';
import { FaArrowLeft } from 'react-icons/fa6';

const Add = () => {
    const [imgUrl, setImgUrl] = useState(null)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const { UploadImage } = useUploadImage("SPECIALIZATION", setLoading, setImgUrl)
    const userData = getlocalStorage("userInfodata")
    const FileRef = useRef()
    const formik = useFormik({
        initialValues: {
            specialization: ""
        },
        validationSchema: SpecializationValidation,
        onSubmit: async (values) => {
            let payload = {
                specializationName: values.specialization,
                providerId: userData?.userId,
                image: imgUrl
            }
            setLoading(true)
            try {
                let response = await INSERT_SPECIALIZATION(payload)
                toast.success(response.message)
                formik.resetForm()
                setTimeout(() => navigate(-1), 1000)
                setLoading(false)
            } catch (error) {
                toast.error(error.message)
                setLoading(false)
            }
        },
    })

    return (
        <>
            {loading && <Loader />}
            <section className='d-flex align-items-center' >
                <FaArrowLeft className='BACK_ICON' onClick={() => navigate(-1)} />
                <h3 className='PAGE-NAME'> Add Specialization</h3>
            </section>
            <div className="container-fluid shadow p-3">
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-sm-12 m-auto">
                            <div className="row d-flex justify-content-center">
                                <div className="col-lg-4 col-xl-3 col-sm-6 col-md-4  col-8">
                                    <div className="bodrerer mb-4 d-flex justify-content-center align-items-center" style={{ border: `${!imgUrl ? "2px dashed #aaaaaa" : "none"}` }}>
                                        <label htmlFor="inputTag">
                                            <AiOutlineCloudUpload className="fs-4 " />
                                            {imgUrl && <img src={SpecializationImageFilePath + imgUrl} alt="" />}
                                            <input ref={FileRef} id="inputTag" type="file" name="file" onChange={(e) => UploadImage(e, FileRef,imgUrl)} />
                                            <br /> Upload an Image<br />
                                            <span id="imageName"></span>
                                        </label>
                                        {imgUrl && <DeleteIcons setLoading={setLoading} setImgUrl={setImgUrl} deletedData={{ fileName: imgUrl, type: "SPECIALIZATION", id: null }} isDeleted={true} />}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <label htmlFor="exampleInputEmail1" className=''>Specialization<span className='Star_Mark'>*</span></label>
                            <TextInput
                                handleChange={(e) => formik.setFieldValue("specialization", e.target.value)}
                                maxLength={50}
                                name="specialization"
                                value={formik.values.specialization}
                                type="text"
                                size='small'
                            />
                            <Errors formikfun={formik} name={"specialization"} />
                        </div>
                        <div className="col-12 text-end">
                            <Button type="submit" className="my-3 mui_button_color save_btn">save</Button>

                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}

export default Add
